(function (W, $, D, Drupal) {
  "use strict";

  if (typeof W.sg === "undefined") {
    W.sg = {};
  }

  let sg = W.sg,
    $D = $(D);

  const $sliders = $(".slider-type-1"),
    prevLabel = Drupal.t("Précédent", {}, { context: "accessibilite" }),
    nextLabel = Drupal.t("Suivant", {}, { context: "accessibilite" });

  let resizeUniqueSlide = ($slider) => {
    let $slide = $slider.find(".slider-type-1-item");
    $slide.css('min-height', '');
    let $slideHeight = $slide.outerHeight();
    $slide.css('min-height', $slideHeight);
  };

  let pushSliderType1 = (() => {
    /**
     * @function sliderInit
     * Set slider options
     */
    let sliderInit = ($slider) => {
        $slider.slick({
          appendArrows: $slider.next(".slider-type-1-controls"),
          appendDots: $slider.next(".slider-type-1-controls"),
          dots: false,
          infinite: true,
          arrows: true,
          speed: 1000,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "47px",
          autoplay: true,
          autoplaySpeed: 5000,
          pauseOnHover: false,
          label: "",
          prevArrow:
            '<button id="prev-slider-type-1" class="slick-prev" aria-label="Aller sur la diapositive précédente" type="button"><span class="slick-arrow-label sr-only">' +
            prevLabel +
            "</span></button>",
          nextArrow:
            '<button id="next-slider-type-1" class="slick-next" aria-label="Aller sur la diapositive suivante" type="button"><span class="slick-arrow-label sr-only">' +
            nextLabel +
            "</span></button>",
          responsive: [
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 2,
                centerMode: false,
                centerPadding: "0",
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                centerMode: false,
                centerPadding: "0",
              },
            },
          ],
        });
      },
      /**
       * @function sliderResize
       * Unslick slider on desktop
       */
      sliderResize = () => {
        if (!sg.viewport.isMobile() && !sg.viewport.isPortrait()) {
          $sliders.map((i, el) => {
            let $slider = $(el);
            if ($slider.hasClass("slick-initialized")) {
              $slider.slick("unslick");
              $slider.find(".item").removeAttr("role");
            }
          });
        } else {
          $sliders.map((i, el) => {
            let $slider = $(el);
            if (!$slider.hasClass("slick-initialized")) {
              pushSliderType1.sliderInit($slider);
              $slider.find(".item").attr("role", "tabpanel");
            }
          });
        }
      },
      sliderPauseAutoplay = ($slider) => {
        $slider.slick("slickPause");
      },
      sliderPlayAutoplay = ($slider) => {
        $slider.slick("slickPlay");
      },
      oMod = {
        sliderInit: sliderInit,
        sliderResize: sliderResize,
        sliderPauseAutoplay: sliderPauseAutoplay,
        sliderPlayAutoplay: sliderPlayAutoplay,
      };

    return oMod;
  })();

  $D.ready(function () {
    $sliders.map((i, el) => {
      let $slider = $(el);
      pushSliderType1.sliderInit($slider);
      const $slideNumber = $slider.find(".slider-type-1-item").length;
      if ($slideNumber === 1) {
        resizeUniqueSlide($slider);
      }
      else {
        $slider.parent().find('.slider-type-1-controls').css('display', 'flex');
      }
      let $pauseButton = $slider
        .parents(".paragraph--type--slider-type-1")
        .find(".slick-pause");
      $pauseButton.click(() => {
        if ($pauseButton.hasClass("paused")) {
          pushSliderType1.sliderPlayAutoplay($slider);
          $pauseButton.removeClass("paused");
        } else {
          pushSliderType1.sliderPauseAutoplay($slider);
          $pauseButton.addClass("paused");
        }
      });
    });

    $(W).resize(function () {
      $sliders.map((i, el) => {
        let $slider = $(el);
        resizeUniqueSlide($slider);
      });
    });

    let prevBtn = document.getElementById('prev-slider-type-1');
      let nextBtn = document.getElementById('next-slider-type-1');
      let focusTarget = document.querySelector('.slider-type-1');
  
      nextBtn.addEventListener('click', function() {
        focusTarget.focus();
      });
      prevBtn.addEventListener('click', function() {
        focusTarget.focus();
      });
  });
})(window, window.jQuery, document, window.Drupal);
